import { hasOneOf } from '@/libs/tools'
import { getCookieAccess } from '@/libs/util'

/**
 * 权限控制指令
 */
export default {
    mounted: function (el, binding) {
        let access = getCookieAccess()
        let codes = binding.value
        if (codes) {
            codes = binding.value.toString().split(',').map(x => x)
        }
        if (!hasOneOf(codes, access)) {
            el.style.display = 'none'
        }
    }
}
